<template>
  <div class="select-union">
    <template v-for="(name, index) in this.newNames">
      <div v-if="getOptions(index).length > 0" :key="name.id" class="select-union__item">
        <div
          :class="
            'select-union__item__field ' +
            (index > 1 && !showChildrenImmediately ? 'select-union__item__field--with-remove' : '')
          "
        >
          <m4-select
            :name="index > 0 ? name.name + '[]' : name.name"
            :value="getValues(name, index)"
            :options="getOptions(index)"
            v-bind="getAttrs(index)"
            @update:modelValue="(val) => changeValue(index, val)"
          ></m4-select>
        </div>
        <div
          v-if="index > 1 && !showChildrenImmediately && getOptions(index).length > 0 && !isDisabled()"
          class="select-union__item__remove"
        >
          <a class="select-value-field-group__row__col__remove" @click="removeItem(index)">
            <m4-icon icon="close"></m4-icon>
          </a>
        </div>
        <div v-if="computedBeforeAlerts && computedBeforeAlerts.length > 0 && index === 0">
          <div v-for="(alert, index) in computedBeforeAlerts" :key="index + '_ba'">
            <m4-alert :variant="alert.variant" bottom-arrow class="margin-t-lg margin-b-lg">
              <span v-html="alert.text"></span>
            </m4-alert>
          </div>
        </div>
      </div>
    </template>
    <template v-for="(name, index) in this.newNames">
      <div v-if="getInputs(index).length > 0" :key="index + 'inputs'">
        <m4-alert variant="default" bottom-arrow class="margin-t-lg margin-b-lg">
          <span v-html="getInputPlaceholder"></span>
        </m4-alert>
        <m4-input
          v-for="(input, inputIndex) in getInputs(index)"
          :key="index + '+' + inputIndex"
          :name="(newNames[1] !== undefined ? newNames[1].name : name.name) + '[' + input.name + ']'"
          :placeholder="input.label"
          :type="input.type"
          :value="getInputValues(input.name, inputIndex)"
          :disabled = "$attrs.disabled"
          class="margin-b-md"
        >
        </m4-input>
      </div>
    </template>
    <m4-button
      v-if="
        this.showNewItemBtn &&
        this.newNames.length > 1 &&
        this.newValues &&
        this.newValues.length > 0 &&
        maxAllowedNewItems > 0 &&
        maxAllowedNewItems > this.newNames.length - 2 &&
        !isDisabled()
      "
      tag="a"
      size="sm"
      variant="primary"
      left-icon="plus"
      @click="addNewRow"
    >
      {{ placeholderAddBtn }}
    </m4-button>
    <div v-for="(alert, index) in computedAlerts" :key="index + '_a'">
      <m4-alert :variant="alert.variant" class="margin-t-mlg margin-b-md">
        <span v-html="alert.text"></span>
      </m4-alert>
    </div>
  </div>
</template>

<script>
export default {
  name: "M4SelectUnion",
  data() {
    let nextId = 0;
    let names;
    let values = [];

    if (typeof this.values === "object") {
      Object.values(this.values).map((val) => {
        if (typeof val === "string") {
          values.push(val);
        } else if (val === null) {
          values.push("");
        } else {
          val.map((v) => {
            values.push(v);
          });
        }
      });
    } else {
      values = this.values;
    }

    if (values && values.length > 1) {
      names = values.map((val, index) => {
        return {
          id: nextId++,
          name: this.names[index] !== undefined ? this.names[index] : this.names[1]
        };
      });
    } else {
      names = this.names.map((name) => {
        return {
          id: nextId++,
          name: name
        };
      });
    }

    names = this.setAllNewValues(names, values, null);

    return {
      newNames: names,
      newValues: values,
      newInputValues: this.inputValues,
      nextId: nextId
    };
  },
  props: {
    names: Array,
    placeholders: Array,
    labels: Array,
    emptyStrings: Array,
    values: [Array, Object],
    inputValues: [Object],
    options: Array,
    alerts: [Object],
    beforeAlerts: [Object],
    disabledChildren: Array,
    placeholderAddBtn: {
      type: String,
      default() {
        return "Add new item";
      }
    },
    maxAllowedNewItems: {
      type: Number,
      default() {
        return 2;
      }
    },
    showChildrenImmediately: {
      type: Boolean,
      default: false
    },
    showNewItemBtn: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    computedAlerts() {
      let allValues = [];
      let allAlerts = {};
      if (this.alerts && Object.values(this.alerts).length > 0 && this.newValues && this.newValues.length > 0) {
        Object.values(this.newValues).forEach((val) => {
          if (typeof val === "string") {
            allValues.push(val);
          }
          if (typeof val === "object") {
            allValues = allValues.concat(val);
          }
        });

        if (allValues.length > 0) {
          allValues.forEach((val) => {
            if (this.alerts[val] !== undefined) {
              allAlerts[val] = this.alerts[val];
            }
          });
        }
      }

      return Object.values(allAlerts);
    },
    computedBeforeAlerts() {
      let allValues = [];
      let allAlerts = {};
      if (
        this.beforeAlerts &&
        Object.values(this.beforeAlerts).length > 0 &&
        this.newValues &&
        this.newValues.length > 0
      ) {
        Object.values(this.newValues).forEach((val) => {
          if (typeof val === "string") {
            allValues.push(val);
          }
          if (typeof val === "object") {
            allValues = allValues.concat(val);
          }
        });

        if (allValues.length > 0) {
          allValues.forEach((val) => {
            if (this.beforeAlerts[val] !== undefined) {
              allAlerts[val] = this.beforeAlerts[val];
            }
          });
        }
      }

      return Object.values(allAlerts);
    },
    getInputPlaceholder() {
      if (this.newValues && this.newValues[0]) {
        let activeOption = this.options.find((option) => {
          return option.value + "" === this.newValues[0] + "";
        });
        if (activeOption && activeOption.inputs_main_label) {
          return activeOption.inputs_main_label;
        }
      }
      return "";
    }
  },
  methods: {
    setAllNewValues(names, values, currSelectedValue) {
      if (this.showChildrenImmediately) {
        let nextId = names.length;
        let missing = this.maxAllowedNewItems + 2 - names.length;

        let activeOption = this.options.find((option) => {
          return option.value + "" === values[0] + "" || option.value + "" === currSelectedValue + "";
        });

        if (
          activeOption &&
          activeOption.inputs &&
          activeOption.inputs.length > 0 &&
          activeOption.children_placeholder
        ) {
          missing = 0;
        }

        for (let i = 0; i < missing; i++) {
          names.push({
            id: nextId++,
            name: this.names[1] !== undefined ? this.names[1] : this.names[0]
          });
        }
      }

      return names;
    },
    addNewRow(e) {
      this.newNames.push({
        id: this.nextId++,
        name: this.names[1]
      });
      e.stopPropagation();
      return false;
    },
    removeItem(index) {
      if (index > -1 && this.newNames.length > 0) {
        this.newNames.splice(index, 1);
        this.newValues.splice(index, 1);
      }
    },
    getValues(name, index) {
      return this.newValues && this.newValues[index] !== undefined ? this.newValues[index] : null;
    },
    getInputValues(name) {
      if (this.newInputValues && this.newInputValues[name] && this.newInputValues[name] !== null) {
        return this.newInputValues[name];
      }
      return "";
    },
    getInputs(index) {
      if (index === 0 && this.newValues && this.newValues[0]) {
        let activeOption = this.options.find((option) => {
          return option.value + "" === this.newValues[0] + "";
        });
        return activeOption && activeOption.inputs && activeOption.inputs.length > 0 ? activeOption.inputs : [];
      }

      return [];
    },
    getOptions(index) {
      if (index > 0) {
        if (this.newValues && this.newValues[0]) {
          let activeOption = this.options.find((option) => {
            return option.value + "" === this.newValues[0] + "";
          });
          if (activeOption && activeOption.children) {
            return activeOption.children.map((child) => {
              if (
                this.disabledChildren &&
                (this.disabledChildren.includes(child.value) || this.disabledChildren.includes(child.value + ""))
              ) {
                child.disabled = true;
              }
              return child;
            });
          }
        }
        return [];
      } else {
        return this.options;
      }
    },
    getAttrs(index) {
      let attrs = {};
      if (this.newValues && this.newValues[0]) {
        let activeOption = this.options.find((option) => {
          return option.value + "" === this.newValues[0] + "";
        });
        if (activeOption && activeOption.children_placeholder) {
          attrs["placeholder"] = activeOption.children_placeholder;
        } else {
          //original
          if (this.placeholders && this.placeholders[index] !== undefined) {
            attrs["placeholder"] = this.placeholders[index];
          } else if (this.placeholders && index > 1 && this.placeholders[1] !== undefined) {
            attrs["placeholder"] = this.placeholders[1];
          }
        }
      } else {
        if (this.placeholders && this.placeholders[index] !== undefined) {
          attrs["placeholder"] = this.placeholders[index];
        } else if (this.placeholders && index > 1 && this.placeholders[1] !== undefined) {
          attrs["placeholder"] = this.placeholders[1];
        }
      }

      if (this.emptyStrings && this.emptyStrings[index] !== undefined) {
        attrs["emptyString"] = this.emptyStrings[index];
      } else if (this.emptyStrings && index > 1 && this.emptyStrings[1] !== undefined) {
        attrs["emptyString"] = this.emptyStrings[1];
      }

      if (this.labels && this.labels[index] !== undefined) {
        attrs["labelAbove"] = this.labels[index];
      } else if (this.labels && index > 1 && this.labels[1] !== undefined) {
        attrs["labelAbove"] = this.labels[1];
      }
      if (this.isDisabled()) {
        attrs["readonly"] = true;
        attrs["disabled"] = true;
      }
      if (index > 0) {
        if (this.newValues && this.newValues[0]) {
          //
        } else {
          attrs["disabled"] = true;
        }
      }
      return attrs;
    },
    isDisabled() {
      return this.$attrs.disabled !== undefined && this.$attrs.disabled;
    },
    changeValue(index, val) {
      if (index === 0) {
        this.nextId = 0;
        this.newNames = [];
        if (this.names[0] !== undefined) {
          this.newNames.push({
            id: this.nextId++,
            name: this.names[0]
          });
        }
        if (this.names[1] !== undefined) {
          this.newNames.push({
            id: this.nextId++,
            name: this.names[1]
          });
        }
        this.newNames = this.setAllNewValues(this.newNames, this.newValues, val);
      }

      this.newValues[index] = val;
    }
  }
};
</script>
